// removed by extract-text-webpack-plugin
module.exports = {"home":"styles-module__home___3KyrC styles-module__container___3efux","cursor":"styles-module__cursor___19n69","blinker":"styles-module__blinker___175ha"};


//////////////////
// WEBPACK FOOTER
// /opt/build/repo/src/containers/Home/styles.module.css
// module id = 184
// module chunks = 0